export default class {
    constructor() {
    }
}
